import { loadView } from '@/router'

export default [
  {
    path: 'ratecards',
    name: 'manage-ratecards',
    component: loadView('Application/Manage/RateCards'),
    showInAlfred: true,
    alfredTitle: 'Manage - Rate Cards'
  }
]
